export const keys = {
  title: 'title',
  linkLabel: 'linkLabel',
  settings: 'settings',
  rejectAll: 'rejectAll',
  acceptAll: 'acceptAll',
  saveSettings: 'saveSettings',
  dialog: {
    title: 'dialog.title',
    description: 'dialog.description',
  },
};
